import { createControlFn } from "../create-control-fn"

const controlNumberFieldFn = createControlFn({
  filterValueCb: (value) => /^[0-9]*$/.test(value as string) || value === "",
})

export { controlNumberFieldFn }
